import {
    Component,
    Inject,
    OnInit,
    ViewChildren,
    QueryList,
    LOCALE_ID,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { PurchaseOrders } from "../../../_models/table-models";
import { PosService } from "src/app/_services/posService";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
declare var $: any;

import { DataExportService } from "src/app/_services/dataExportService";
import { formatDate } from "@angular/common";

@Component({
    selector: "app-purchase-orders",
    templateUrl: "./purchase-orders.component.html",
    styleUrls: ["./purchase-orders.component.scss"],
})
export class PurchaseOrdersComponent implements OnInit {
    searchTerm: string = "";
    public isCollapsed = false;
    purchase_orders: PurchaseOrders[] = [];
    allPurchaseOrders: PurchaseOrders[] = [];
    responseData: any;
    isError: any;
    isEmpty = false;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    pos: any;
    filterKey: any;
    loading = true;
    loadingDetailsSet = new Set<string>();
    loadedDetailsSet = new Set<string>();
    sessionExpired = false;
    errorMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    selectedOption = false;
    filterBy: any;
    tableData: any;
    impersonate;

    constructor(
        private router: Router,
        private authService: AuthService,
        private posService: PosService,
        private exportService: DataExportService,
        @Inject(LOCALE_ID) public locale: string
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");

        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }

        //console.log(this.impersonate);

        const userData = {
            action: "list",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fetchPurchaseOrdersList(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                if (this.responseData.status == "successful") {
                    this.purchase_orders = this.responseData.pos;
                    this.allPurchaseOrders = this.responseData.pos;
                    this.collectionSize = this.responseData.pos.length;
                    this.refreshPos();
                } else {
                    this.loading = false;
                    this.isEmpty = true;
                }
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
            }
        );
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    refreshPos() {
        let sortedPos = this.purchase_orders.sort((a, b) =>
            a.creation_date > b.creation_date ? 1 : -1
        );
        this.pos = sortedPos
            .map((po, i) => ({ id: i + 1, ...po }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
        this.fetchDetailsForCurrentPage();
    }

    refreshData() {
        this.loading = true;
        this.isEmpty = false;
        this.purchase_orders = [];
        this.allPurchaseOrders = [];
        this.pos = [];
        this.page = 1;
        this.loadingDetailsSet.clear();
        this.loadedDetailsSet.clear();

        const userData = {
            action: "list",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fetchPurchaseOrdersList(userData).subscribe({
            next: (res: any) => {
                this.loading = false;
                this.responseData = res;
                if (this.responseData.status == "successful") {
                    this.purchase_orders = this.responseData.pos;
                    this.allPurchaseOrders = this.responseData.pos;
                    this.collectionSize = this.responseData.pos.length;
                    this.refreshPos();
                } else {
                    this.isEmpty = true;
                }
            },
            error: (error) => {
                this.loading = false;
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                }
            },
        });
    }

    fetchDetailsForCurrentPage() {
        const posToFetch: any[] = (this.pos || []).filter(
            (po: any) =>
                !this.loadedDetailsSet.has(po.po_no) &&
                !this.loadingDetailsSet.has(po.po_no)
        );

        if (posToFetch.length === 0) return;

        const poNosToFetch: string[] = posToFetch.map((po: any) => po.po_no);
        const idsToFetch: string[] = posToFetch.map((po: any) => po._id);

        poNosToFetch.forEach((poNo) => this.loadingDetailsSet.add(poNo));

        const detailsPayload = {
            action: "list",
            sellerCode: localStorage.getItem("vendorCode"),
            poNos: poNosToFetch,
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fetchPurchaseOrderDetails(detailsPayload).subscribe(
            (detailsRes: any) => {
                poNosToFetch.forEach((poNo) => {
                    this.loadingDetailsSet.delete(poNo);
                    this.loadedDetailsSet.add(poNo);
                });
                if (detailsRes.status === "successful" && detailsRes.pos) {
                    const detailsMap = new Map<string, Record<string, any>>(
                        detailsRes.pos.map((d: any) => [d.po_no, d] as [string, Record<string, any>])
                    );
                    this.purchase_orders = this.purchase_orders.map((po) => ({
                        ...po,
                        ...(detailsMap.get(po.po_no) || {}),
                    }));
                    this.allPurchaseOrders = this.allPurchaseOrders.map(
                        (po) => ({
                            ...po,
                            ...(detailsMap.get(po.po_no) || {}),
                        })
                    );
                    // Update only the current page slice — avoid calling refreshPos()
                    // which would re-trigger fetchDetailsForCurrentPage()
                    this.pos = (this.pos || []).map((po: any) => ({
                        ...po,
                        ...(detailsMap.get(po.po_no) || {}),
                    }));
                }
            },
            () => {
                poNosToFetch.forEach((poNo) =>
                    this.loadingDetailsSet.delete(poNo)
                );
            }
        );
    }

    onFilter(option: any) {
        this.filterBy = option.target.value;
        console.log(this.filterBy + " option selected");
        this.selectedOption = true;
    }

    onSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            if (this.filterBy === "po_number") {
                this.pos = this.allPurchaseOrders.filter((data) =>
                    (data.po_no as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "location") {
                this.pos = this.allPurchaseOrders.filter((data) =>
                    (data.location as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else {
                this.pos = this.allPurchaseOrders.filter((data) =>
                    (data.po_currency as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            }
        } else {
            this.pos = this.purchase_orders;
        }
        this.fetchDetailsForCurrentPage();
    }

    generalSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            this.pos = this.allPurchaseOrders.filter(
                (data) =>
                    (data.po_no as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    (data.po_currency as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
            );
        } else {
            this.pos = this.purchase_orders;
        }
        this.fetchDetailsForCurrentPage();
    }

    trackPoNumber(index: number, po: any) {
        return this.pos ? this.pos : undefined;
    }

    exportToExcel() {
        const date = new Date();

        const fileName =
            (this.displayName = localStorage.getItem("vendorCode")) +
            "_Purchase_Order_Table_" +
            formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

        if (this.selectedOption === false) {
            this.tableData = this.purchase_orders;
        } else {
            this.tableData = this.pos;
        }

        const cols = [
            {
                name: "PO No",
                colKey: "po_no",
            },
            {
                name: "PO Type",
                colKey: "po_ses_mat",
            },
            {
                name: "Location",
                colKey: "location",
            },
            {
                name: "PO Amount",
                colKey: "po_value",
            },
            {
                name: "Open PO Amount",
                colKey: "openPoValue",
            },
            {
                name: "Invoiced Amount",
                colKey: "invoicedAmount",
            },
            {
                name: "In-Process Invoice Amount",
                colKey: "inProcessInvoicedAmount",
            },
            {
                name: "PO Currency",
                colKey: "po_currency",
            },
        ];

        this.exportService.exportToExcel(this.tableData, cols, fileName);
    }
}
